import { Checkbox, Form, InputNumber } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const ContributionInput = ({ value, onChange, isMarried, hideCommunityProperty, ...rest }) => {
  const { t } = useTranslation('proposalRequest');
  
  const onInputChange = useCallback((e) => {
    onChange && onChange({ ...value, value: e });
  }, [onChange, value]);
  
  const onActiveChange = useCallback((e) => {
    onChange && onChange({ ...value, isMatrimonialCommunity: e?.target?.checked });
  }, [onChange, value]);
  
  return (
    <div className="flex md:flex-row flex-col md:items-center w-full">
      <div className="md:max-w-64 md:mr-4 mb-2 md:mb-0">
        <Form.Item className="w-full mb-0" initialValue={0}>
          <InputNumber
            {...rest}
            value={value?.value}
            onChange={onInputChange}
            formatter={(value) => value ? `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}
            parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
            size={'large'}
            placeholder={t('amountPlaceHolder')}
            min={0}/>
        </Form.Item>
      </div>
      {(isMarried && !hideCommunityProperty) && <Checkbox
        defaultChecked={value?.isMatrimonialCommunity}
        checked={value?.isMatrimonialCommunity}
        className={classNames('mx-0 my-px')}
        size={'large'}
        onChange={onActiveChange}>{t('proposalRequest.form.partners.isMatrimonialCommunity.question')}</Checkbox>}
    </div>
  
  );
  
};

ContributionInput.propTypes = {
  isMarried: PropTypes.bool,
  hideCommunityProperty: PropTypes.bool,
  index: PropTypes.number,
  value: PropTypes.object,
  onChange: PropTypes.func
};

ContributionInput.defaultProps = {};

export default memo(ContributionInput);
